import PropTypes from 'prop-types'

import styles from './activeFilters.module.scss'

/**
 * Was die Liste gerade einschränkt — an einer Stelle, mit einem Ausschalter.
 *
 * Gefiltert wird in dieser Ansicht an sechs verschiedenen Stellen: im Trichter,
 * in der Verteilung nach Personen, in der Herkunftsleiste, in der Auswertung je
 * Bundesland, in der Filterleiste und im Suchfeld. Jede zeigt für sich, dass
 * sie aktiv ist — aber wer von oben nach unten liest, hat die erste vergessen,
 * bevor er bei der letzten ist. Am Ende steht eine kurze Liste und niemand
 * weiß, warum.
 *
 * Diese Leiste beantwortet das in einer Zeile: je Einschränkung ein Schild mit
 * **Gruppe und Wert** („Status: In Arbeit"), Klick entfernt genau diese eine —
 * und rechts der Knopf, der alle auf einmal wegräumt. Sie klebt beim Scrollen
 * oben, weil die Frage „warum sehe ich nur sieben Zeilen" erst unten in der
 * Liste aufkommt.
 *
 * Ohne Einschränkung ist sie nicht da: Eine Leiste, die „keine Filter" meldet,
 * ist eine Zeile, die man täglich liest und nie braucht.
 */
export default function ActiveFilters({ eintraege, onEntfernen, onAllesZuruecksetzen }) {
	if (!eintraege.length) return null

	return (
		<section className={styles.root} aria-label="Aktive Filter">
			<span className={styles.titel}>
				Aktive Filter
				<span className={styles.zahl}>{eintraege.length}</span>
			</span>

			<div className={styles.chips}>
				{eintraege.map(eintrag => (
					<button
						key={eintrag.id}
						type="button"
						className={styles.chip}
						title={`„${eintrag.gruppe}: ${eintrag.label}" entfernen`}
						onClick={() => onEntfernen(eintrag)}
					>
						<span className={styles.gruppe}>{eintrag.gruppe}</span>
						<span className={styles.wert}>{eintrag.label}</span>
						<span className={styles.kreuz} aria-hidden="true">
							×
						</span>
					</button>
				))}
			</div>

			<button type="button" className={styles.reset} onClick={onAllesZuruecksetzen}>
				Alle Filter zurücksetzen
			</button>
		</section>
	)
}

ActiveFilters.propTypes = {
	/*
	 * Je Einschränkung ein Eintrag. `feld` und `wert` sagen, was beim Klick auf
	 * das Kreuz zurückzunehmen ist; `gruppe` und `label` sind die Wörter der
	 * Oberfläche und werden hier nur angezeigt, nicht gedeutet.
	 */
	eintraege: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			gruppe: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			feld: PropTypes.string.isRequired,
			wert: PropTypes.any
		})
	).isRequired,
	onEntfernen: PropTypes.func.isRequired,
	onAllesZuruecksetzen: PropTypes.func.isRequired
}
